/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  CreateBulkInviteFromFileBackoffice1Payload,
  CreateBulkInviteFromFilePayload,
  CreateBulkInviteRequest,
  CreateBulkInviteResponse,
  EmailProviderResponse,
  FindCandidatesParams,
  Invitee,
  SignUpFromInviteParams,
  SignUpFromInviteRequest,
  UserDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiInviteController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-invite-controller
   * @name ResendInvitation
   * @request POST:/api/v1/invite/{organisationId}/user/{userId}/resend
   */
  resendInvitation = (organisationId: string, userId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/v1/invite/${organisationId}/user/${userId}/resend`,
      method: 'POST',
      ...params,
    })

  static resendInvitationPath = '/v1/invite/${organisationId}/user/${userId}/resend'
  static resendInvitationMethod = 'POST'
  /**
   * No description
   *
   * @tags api-invite-controller
   * @name SignUpFromInvite
   * @request POST:/api/v1/invite/sign-up
   */
  signUpFromInvite = (
    query: SignUpFromInviteParams,
    data: SignUpFromInviteRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<UserDto, any>({
      path: `/v1/invite/sign-up`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static signUpFromInvitePath = '/v1/invite/sign-up'
  static signUpFromInviteMethod = 'POST'
  /**
   * No description
   *
   * @tags api-invite-controller
   * @name CreateBulkInvite
   * @request POST:/api/v1/invite/bulk
   */
  createBulkInvite = (data: CreateBulkInviteRequest, params: RequestParams = {}) =>
    this.http.request<CreateBulkInviteResponse, any>({
      path: `/v1/invite/bulk`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createBulkInvitePath = '/v1/invite/bulk'
  static createBulkInviteMethod = 'POST'
  /**
   * No description
   *
   * @tags api-invite-controller
   * @name CreateBulkInviteFromFile
   * @request POST:/api/v1/invite/bulk/csv-file-upload
   */
  createBulkInviteFromFile = (data: CreateBulkInviteFromFilePayload, params: RequestParams = {}) =>
    this.http.request<CreateBulkInviteResponse, any>({
      path: `/v1/invite/bulk/csv-file-upload`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static createBulkInviteFromFilePath = '/v1/invite/bulk/csv-file-upload'
  static createBulkInviteFromFileMethod = 'POST'
  /**
   * No description
   *
   * @tags api-invite-controller
   * @name CreateBulkInviteFromFileBackoffice1
   * @request POST:/api/v1/invite/bulk/csv-file-upload/backoffice/{organisationId}
   */
  createBulkInviteFromFileBackoffice = (
    organisationId: string,
    data: CreateBulkInviteFromFileBackoffice1Payload,
    params: RequestParams = {},
  ) =>
    this.http.request<CreateBulkInviteResponse, any>({
      path: `/v1/invite/bulk/csv-file-upload/backoffice/${organisationId}`,
      method: 'POST',
      body: data,
      type: ContentType.FormData,
      format: 'json',
      ...params,
    })

  static createBulkInviteFromFileBackofficePath =
    '/v1/invite/bulk/csv-file-upload/backoffice/${organisationId}'
  static createBulkInviteFromFileBackofficeMethod = 'POST'
  /**
   * No description
   *
   * @tags api-invite-controller
   * @name BulkInviteAccountants
   * @request POST:/api/v1/invite/bulk/accountants
   */
  bulkInviteAccountants = (data: CreateBulkInviteRequest, params: RequestParams = {}) =>
    this.http.request<CreateBulkInviteResponse, any>({
      path: `/v1/invite/bulk/accountants`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static bulkInviteAccountantsPath = '/v1/invite/bulk/accountants'
  static bulkInviteAccountantsMethod = 'POST'
  /**
   * No description
   *
   * @tags api-invite-controller
   * @name FindEmailProvider
   * @request GET:/api/v1/invite/email-provider
   */
  findEmailProvider = (params: RequestParams = {}) =>
    this.http.request<EmailProviderResponse, any>({
      path: `/v1/invite/email-provider`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findEmailProviderPath = '/v1/invite/email-provider'
  static findEmailProviderMethod = 'GET'
  /**
   * No description
   *
   * @tags api-invite-controller
   * @name FindCandidates
   * @request GET:/api/v1/invite/candidates
   */
  findCandidates = (query: FindCandidatesParams, params: RequestParams = {}) =>
    this.http.request<Invitee[], any>({
      path: `/v1/invite/candidates`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static findCandidatesPath = '/v1/invite/candidates'
  static findCandidatesMethod = 'GET'
}
